import { getEnvVar } from "ideas.env";

export const ideasFeatures = {
  organizationsPanel: false,
  partialRefetchLink: false,
  devOnly:
    getEnvVar("CURRENT_REGION").KEY === "local" ||
    getEnvVar("CURRENT_REGION").KEY === "ideas-development",
  genericDataTables: getEnvVar("GDT") === "1",
  demoProjects: getEnvVar("FF_DEMO_PROJECTS") === "1",
  personalSpace: getEnvVar("FF_PERSONAL_SPACE") === "1",
};
